import {
    AuthService,
    challengeSRP,
    initSRP,
    proofSRP,
} from '../../../../auth/Service';
import React, { useState } from 'react';

import { AuthStore } from '../../../../auth/utils/store';
import EditSectionForm from 'ui/form/EditSectionForm';
import PaperContainer from 'ui/PaperContainer';
import { PasswordForm } from './components';
import { SRPHelper } from '../../../../auth/utils/srp';
import { getCode } from '../../service';
import { withSnackbar } from 'notistack';
import zxcvbn from 'zxcvbn';

const Profile = withSnackbar(({ extra: { currentUser }, enqueueSnackbar }) => {
    const [values, setValues] = useState({});
    const [errors, setErrors] = useState({});
    const [visible, setVisible] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = name => value => {
        const newValues = { ...values, ...{ [name]: value } };
        if (name === 'new_password') {
            newValues.passwordScore = zxcvbn(value).score;
        }
        setValues(newValues);
    };

    const handleIncorrectPass = () => {
        setErrors({
            ...errors,
            current_password: 'Incorrect current password',
        });
    };

    const handleAction = async action => {
        switch (action) {
            case 'submit':
                setErrors({});
                setLoading(true);
                let code;
                try {
                    const store = AuthStore.load(currentUser.username);
                    const data = await initSRP(currentUser.username);
                    const srp = new SRPHelper(
                        data.N,
                        data.g,
                        data.k,
                        data.salt
                    );
                    const device = store.getDevice();
                    const challenge = await challengeSRP(
                        currentUser.username,
                        device,
                        srp.largeAValue.toString(16)
                    );
                    const proof = srp.calculateProof(
                        currentUser.username,
                        values.current_password,
                        challenge.server_public_key
                    );
                    let response = await proofSRP(
                        currentUser.username,
                        device,
                        proof.toString(16)
                    );
                    if (response.status === 'success') {
                        response = await getCode(values.current_password);
                        code = response.code;
                        await AuthService.password(
                            currentUser.username,
                            values.new_password,
                            code
                        );
                        const login = await AuthService.login(
                            currentUser.username,
                            values.new_password
                        );
                        if (login.status === 'success') {
                            enqueueSnackbar('Password successfully changed', {
                                variant: 'info',
                            });
                        } else {
                            enqueueSnackbar(
                                'Password changed, but we could not refresh your session. Please log in again.',
                                { variant: 'warning' }
                            );
                        }
                        setValues({});
                        setLoading(false);
                        return;
                    }
                    handleIncorrectPass();
                    setLoading(false);
                } catch (e) {
                    handleIncorrectPass();
                    setLoading(false);
                    return;
                }

                setLoading(false);
                break;
            case 'cancel':
                setValues({});
                setErrors({});
                break;
            default:
        }
    };

    const handleChangeVisible = name => {
        setVisible({ ...visible, [name]: !visible[name] });
    };

    const isEmpty = !values.new_password || !values.confirm_new_password;
    const isEasyPass = !values.passwordScore || values.passwordScore < 1;

    const pageSubtitle = currentUser.pb6_authentication_enabled
        ? 'The password change cannot be done from the partner portal, to change it go to the CyberFOX Password Manager web-app.'
        : 'Note: Changing your Partner Portal password does NOT change your password for the application or the Customer Portal';

    return (
        <PaperContainer
            title="Change Partner Portal Password"
            subtitle={pageSubtitle}
            secondary
        >
            {!currentUser.pb6_authentication_enabled && (
                <EditSectionForm.Form
                    onAction={handleAction}
                    locals={{ save: 'update' }}
                    showProgress={loading}
                    disabledNext={
                        !values.current_password ||
                        isEmpty ||
                        values.new_password !== values.confirm_new_password ||
                        isEasyPass
                    }
                >
                    <PasswordForm
                        values={values}
                        errors={errors}
                        onChange={handleChange}
                        onChangeVisible={handleChangeVisible}
                        visible={visible}
                    />
                </EditSectionForm.Form>
            )}
        </PaperContainer>
    );
});

export { Profile };
